import { Component } from '@angular/core';

@Component({
  selector: 'app-student-verification-landing',
  templateUrl: './student-verification-landing.component.html',
  styleUrls: ['./student-verification-landing.component.scss']
})
export class StudentVerificationLandingComponent {

}
